import * as firebase from 'firebase';

const firebaseConfig = {
  apiKey: "AIzaSyBgk-vjuGRoCpl7-7oktH1FRA3RvjatLqk",
  authDomain: "cm-tim-goo.firebaseapp.com",
  databaseURL: "https://cm-tim-goo.firebaseio.com",
  projectId: "cm-tim-goo",
  storageBucket: "cm-tim-goo.appspot.com",
  messagingSenderId: "1036319296999",
  appId: "1:1036319296999:web:e42173daa139e466330142",
  measurementId: "G-7LZ1JZQBHB"
};
// const firebaseConfig = {
//     apiKey: "AIzaSyBk0hzz68UFtzn5kGq6Co3oZmvzajaT6KY",
//     authDomain: "cm-tim.firebaseapp.com",
//     databaseURL: "https://cm-tim.firebaseio.com",
//     projectId: "cm-tim",
//     storageBucket: "cm-tim.appspot.com",
//     messagingSenderId: "631953110821",
//     appId: "1:631953110821:web:6b40fc559eedafcd1b4ccc"
//   };
  // Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.analytics();

export const autentication = () => {firebase.auth().signInWithEmailAndPassword('it@coordinadora.com', 'leqhddce').then()};

export const firebaseAdmin = firebase;
export const bd = firebase.firestore();